import { t } from "@/i18n-js/instance";
import { TRIGGER_RESOURCE_TYPE } from "@circle-react/components/SettingsApp/Workflows/constants";
import { EntitySelector } from "../../EntitySelector";
import { entityTypeOptions as paywallOptions } from "./AnyPaywallSelector";

const i18nRoot = "settings.workflows.form.entity_type.paywall";

const entityTypeOptions = [
  {
    value: TRIGGER_RESOURCE_TYPE.PAYWALL,
    label: t([i18nRoot, "paywall.title"]),
    description: t([i18nRoot, "paywall.description"]),
  },
  ...paywallOptions,
];

export const AnyPaywallSpecificSelector = () => (
  <EntitySelector entityTypeOptions={entityTypeOptions} />
);
